module.exports = __webpack_public_path__ + "img/MoonSword 6b.d13f729c.png";